import React from 'react'
import '../../styles/ComponentsStyles/Auth/LeftTemp.style.css'
import BackgroundLogo from '../../assets/Images/loginImg/Background_login_logo.png'
import Logo from '../../assets/Images/loginImg/Login_logo.png'
import MacBook from '../../assets/Images/loginImg/MacBook_Air_login.png'
import OMS360 from '../../assets/Images/loginImg/OMS_360_login.png'
import Ad1 from '../../assets/Images/loginImg/ad_login_1.png'
import Ad2 from '../../assets/Images/loginImg/ad_login_2.png'
import UpRightArrow from '../../assets/Icons/Pages/Auth/ArrowUpRight.svg'
import RightArrow from '../../assets/Icons/Pages/Auth/ArrowRight.svg'

const LeftTemp = () => {
    return (
        <div className="left-temp-container">
            <img src={BackgroundLogo} alt="Background OMS" className="background-logo" />
            <div className="top-banner">
                <img src={Logo} alt="Logo" />
                <a href="/" className="about-link" target="_blank" rel="noopener noreferrer">
                    About OMS
                    <img className="UpRightArrow" src={UpRightArrow} alt="UpRightArrow" />
                </a>
            </div>

            {/* Main Content */}
            <div className="main-content">
                <div className="go-to-card">
                    <div className='go-to-card-content'>
                        <a className="go-to-card-text" href='/' target='_blank'>
                            <p> Go to </p>
                            <img src={RightArrow} alt="RightArrow" />
                        </a>
                        <img src={OMS360} alt="OMS360" />
                    </div>
                    <img className="macbook-image" src={MacBook} alt="MacBook" />
                </div>

                <div className="dashboard-previews">
                    <img src={Ad1} alt="Ad Dashboard 1" />
                    <img src={Ad2} alt="Ad Dashboard 2" />
                </div>
            </div>
        </div>
    )
}

export default LeftTemp
